import React from "react";

const ErrorIcon = () => {
  return (
    <svg
      width="485"
      height="177"
      viewBox="0 0 485 177"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_1_219)">
        <path
          d="M115.18 164V127.636H24.2711L6.08923 109.455V18.5455H42.4529V91.2727H115.18V18.5455H151.544V164H115.18ZM442.453 164V127.636H351.544L333.362 109.455V18.5455H369.726V91.2727H442.453V18.5455H478.817V164H442.453Z"
          fill="#232323"
        />
        <path
          d="M278.817 127.636V54.9091H206.089V127.636H278.817ZM187.907 164L169.726 145.818V36.7273L187.907 18.5455H296.998L315.18 36.7273V145.818L296.998 164H187.907Z"
          fill="url(#paint0_linear_1_219)"
        />
      </g>
      <g filter="url(#filter1_i_1_219)">
        <rect
          x="204.483"
          y="53.0304"
          width="75.7576"
          height="75.7576"
          fill="#122549"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1_219"
          x="0.0286274"
          y="18.5455"
          width="484.849"
          height="157.576"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="6.06061" />
          <feGaussianBlur stdDeviation="3.0303" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.537255 0 0 0 0 0.564706 0 0 0 0 0.823529 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1_219"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1_219"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_i_1_219"
          x="204.483"
          y="53.0304"
          width="75.7576"
          height="75.7576"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3.0303" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_1_219"
          />
        </filter>
        <linearGradient
          id="paint0_linear_1_219"
          x1="166.634"
          y1="30.303"
          x2="328.003"
          y2="163.666"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#4AAEFF" stop-opacity="0.7" />
          <stop offset="0.98" stop-color="#29346C" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default ErrorIcon;
